module.exports = __webpack_public_path__ + "static/img/tz.88c89454.svg";